var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { colors } from "@wrstudios/theme";
import { IconSpinner } from "@wrstudios/icons";
import { Container, Loading } from "./styled/user-avatar";
function UserAvatar(_a) {
    var initials = _a.initials, _b = _a.initialsColor, initialsColor = _b === void 0 ? colors.blue[500] : _b, _c = _a.avatarUrl, avatarUrl = _c === void 0 ? "" : _c, _d = _a.size, size = _d === void 0 ? "sm" : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, props = __rest(_a, ["initials", "initialsColor", "avatarUrl", "size", "loading"]);
    return (React.createElement(Container, __assign({ "aria-hidden": true, size: size, avatarUrl: avatarUrl, initialsColor: initialsColor }, props), loading ? (React.createElement(Loading, null,
        React.createElement(IconSpinner, null))) : !avatarUrl ? (initials) : null));
}
export default UserAvatar;
